import React, { isValidElement } from 'react'
import styled from '@emotion/styled'
import convert from 'htmr'
import { HtmrOptions } from 'htmr/src/types'

import { Stack, StackProps } from '../Stack'
import { Heading } from '../Heading'
import { BaseLink } from '../Link'
import { Text } from '../Text'

const UnorderedList = styled('ul')`
  list-style-type: circle;
  padding-left: 2rem;
`
const ListItem = styled('li')`
  margin: 10px 0;
`
const Wrapper = styled(Stack)`
  word-break: break-word;
`

const baseOptions = {
  transform: {
    p: Text,
    h2: props => <Heading {...props} as="h2" />,
    h3: props => <Heading mt={4} {...props} as="h3" />,
    h4: props => <Heading mt={4} {...props} as="h4" />,
    h5: props => <Heading mt={4} {...props} as="h5" />,
    h6: props => <Heading mt={4} {...props} as="h6" />,
    ul: UnorderedList,
    li: ListItem,
    a: props => <BaseLink {...props} isExternal color="pink.500" />,
  },
}

export interface HtmlProps extends StackProps {
  children?: string
  html?: string
  options?: Partial<HtmrOptions>
}

export const Html = ({ children, html, options = {}, ...restProps }: HtmlProps) => {
  const _options = {
    ...baseOptions,
    ...options,
    transform: {
      ...baseOptions.transform,
      ...options.transform,
    },
  }

  const _html = html || children

  return <Wrapper {...restProps}>{convert(_html, _options)}</Wrapper>
}

export default Html
